// angular
//     .module("HeroPRO")
//     .factory("JobNumberPopoverFactory", jobNumberPopoverFactory);

/* @ngInject */
export default function jobNumberPopoverFactory(HPConfig, $http) {
    return {
        deleteContractorJobNumber,
        addEditContractorJobNumber,
    };

    function deleteContractorJobNumber(jobId) {
        const params = { FundingRequestToContractorJobId: jobId };

        return $http({
            url: `${HPConfig.heroProApi}Loan/FundingRequests/ContractorJobs/Delete`,
            method: 'POST',
            data: params,
        });
    }

    function addEditContractorJobNumber(params) {
        return $http({
            url: `${HPConfig.heroProApi}Loan/FundingRequests/ContractorJobs`,
            method: 'POST',
            data: params,
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/common/primaryInformation/jobNumberPopoverFactory.js